import { useEffect, useState } from 'preact/hooks'

/**
 * Verbindungszustand. `navigator.onLine` meldet nur, ob ein Netzwerk-Interface da
 * ist — nicht, ob der Server erreichbar ist. Für den Banner reicht das; die echte
 * Wahrheit liefert ab Phase 4 der WebSocket-Zustand.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(navigator.onLine)

  useEffect(() => {
    const on = () => setOnline(true)
    const off = () => setOnline(false)
    addEventListener('online', on)
    addEventListener('offline', off)
    return () => {
      removeEventListener('online', on)
      removeEventListener('offline', off)
    }
  }, [])

  return online
}
